import { useSyncExternalStore } from 'react';

/**
 * GH#2765 — estado «el ERP no está desplegado», aprendido del propio API. Decisión de Randhy (13-oct, vía la HUB): el ERP NO se quita del menú,
 * «es mejor solo terminarlo»; lo que se evita es enseñar KPIs en cero y «No se pudo cargar ningún dato del ERP». `erp-proxy-api` marca el estado
 * al ver un 503 `ERP_NOT_AVAILABLE` y `ErpDisponible` cambia la pantalla por «en construcción». «Reintentar» lo limpia (si el ERP ya existe, las
 * pantallas cargan; si no, vuelve a marcarse). Estado de módulo: se pierde al recargar, así que cuando el ERP se despliegue no hay nada que apagar.
 */
let noDisponible = false;
const oyentes = new Set<() => void>();
const avisar = () => oyentes.forEach((o) => o());

export function marcarErpNoDisponible(): void {
  if (noDisponible) return;
  noDisponible = true;
  avisar();
}

export function reintentarErp(): void {
  if (!noDisponible) return;
  noDisponible = false;
  avisar();
}

export const erpNoDisponible = (): boolean => noDisponible;

const suscribir = (oyente: () => void) => {
  oyentes.add(oyente);
  return () => {
    oyentes.delete(oyente);
  };
};

export function useErpNoDisponible(): boolean {
  return useSyncExternalStore(suscribir, erpNoDisponible, erpNoDisponible);
}
